import { useRuntimeConfig } from '#imports'

export const getMetaData = (book, route) => {
  const config = useRuntimeConfig()

  return [
    {
      property: 'og:title',
      content: `${book.title} - ${book.author?.name}`,
    },
    {
      property: 'og:url',
      content: `${config.public.BASE_URL}${route.fullPath}`,
    },
    {
      property: 'og:image',
      content: `${book.cover}&width=136&height=209&fit=cover`,
    },
    {
      property: 'og:image:secure_url',
      content: `${book.cover}&width=136&height=209&fit=cover`,
    },
    {
      property: 'og:image:type',
      content: 'image/jpg',
    },
    {
      property: 'og:description',
      content: book.shortDescription,
    },
    {
      property: 'og:type',
      content: 'book',
    },
    {
      property: 'og:locale',
      content: 'nl_NL',
    },
    {
      name: 'description',
      content: book.shortDescription,
    },
  ]
}

export const getStructuredData = (book) => {
  const bookData = {
    '@context': 'https://schema.org',
    '@type': 'Book',
    name: book.title,
    author: book.author?.name,
    image: book.cover,
    inLanguage: 'nl-NL',
    description: book.shortDescription,
    genre: book.genres && book.genres[0],
  }

  if (book.numberOfRatings) {
    bookData.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: book.averageRating.toString(),
      reviewCount: book.numberOfRatings.toString(),
      bestRating: '5',
    }
  }

  return bookData
}
